import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { fetchLanguageResource } from './utils/formsApi';
import { apiDomain } from './utils/apiClient';

const initialLanguage = new URLSearchParams(window.location.search).get('lang') || 'en-US';

i18n
  .use(HttpBackend) // Enables loading translations from the server
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    debug:false,
    // Read the URL before React renders so only the requested language is loaded.
    lng: initialLanguage,
    fallbackLng: false,
    load: 'currentOnly',
    maxRetries: 0,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: true, // Enables React Suspense for async loading
    },// Backend options configuration
    backend: {
      // i18next interpolates {{lng}} and {{ns}} dynamically. This relative URL
      // is resolved against REACT_APP_API_BASE_URL by apiClient.
      loadPath: `api/languages/${encodeURIComponent(apiDomain)}/{{lng}}?scope={{ns}}`,
      request: (
        _options: unknown,
        url: string,
        _payload: {} | string,
        callback: (error: unknown | null, response: { status: number; data: any }) => void,
      ) => {
        fetchLanguageResource(url)
          .then((response) => {
            callback(null, {
              status: response.status,
              data: response.data,
            });
          })
          .catch((error: any) => {
            callback(error, {
              status: error.response?.status ?? 0,
              data: error.response?.data,
            });
          });
      },
    },
  });

export default i18n;
